import { render } from "./Home.vue?vue&type=template&id=b7c6b87c&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=b7c6b87c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7c6b87c"]])

export default __exports__